var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSqldbIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 245 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3, .cls-2 {\r\n        stroke-width: 15px;\r\n      }\r\n\r\n      .cls-3, .cls-2, .cls-4 {\r\n        stroke: #df6c20;\r\n      }\r\n\r\n      .cls-3, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-width: 10px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "209.7 210.6 124.7 230 42.3 210.6 42.3 66.5 209.7 66.5 209.7 210.6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 124.7,
    cy: 45,
    rx: 85,
    ry: 35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.7,45v150c1.7,19.4,41,35.1,88,35.1s83.7-15.7,82-35.1V45M39.7,95c1.7,19.4,41,35.1,88,35.1s83.7-15.7,82-35.1h0M39.7,145c1.7,19.4,41,35.1,88,35.1s83.7-15.7,82-35.1h0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "201.9 178.9 123.4 205.7 47.4 181.6 47.4 141.6 201.9 141.6 201.9 178.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.1,161.3c0-7.6-6.2-13.8-13.8-13.8s-13.8,6.2-13.8,13.8h0c-.3,7.6,4.5,14,10.6,14.3,1.1,0,2.2-.1,3.2-.5,6.1,0,11.1,6.1,11.1,13.7,0,0,0,0,0,.1-.8,7.6-7.6,13.2-15.2,12.4-7.6-.8-13.2-7.6-12.4-15.2h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.6,202.8c-15.1,2.5-29.3-7.7-31.8-22.8-2.5-15.1,7.7-29.3,22.8-31.8,15.1-2.5,29.3,7.7,31.8,22.8,1.9,11.8-3.9,23.5-14.5,29M131.6,188.9l16.6,22.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.5,144.7v44.2c0,7.6,6.2,13.8,13.8,13.8h11.1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqldbIcon);
export default __webpack_public_path__ + "static/media/sqldb_icon.8f49afa859cef2acfcfc2c0c2ffc4d86.svg";
export { ForwardRef as ReactComponent };